import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';

import { Container, Row, Column } from '../../styleguide/grid/index';
import Breadcrumbs from '../breadcrumbs/index';

const S = {};

S.BreadcrumbsWrapper = styled.div`
  background: ${({ theme }) => _.get(theme, 'breadcrumbsBar.background', '#efefef')};
  border: ${({ theme }) => _.get(theme, 'breadcrumbsBar.border')};
`;

S.Inner = styled.div`
  padding: ${({ theme }) => _.get(theme, 'breadcrumbsBar.padding', '20px 0')};
`;

const BreadcrumbsBar = ({ containerWidth, withSameLevels = true }) => {
  return (
    <S.BreadcrumbsWrapper>
      <Container maxWidth={containerWidth}>
        <Row>
          <Column size={{ xs: 12 }}>
            <S.Inner>
              <Breadcrumbs withSameLevels={withSameLevels} />
            </S.Inner>
          </Column>
        </Row>
      </Container>
    </S.BreadcrumbsWrapper>
  );
};

export default BreadcrumbsBar;
